export default __webpack_public_path__ + "static/media/S_wdt_c_cap_0.e2a7f039.mp3";